import { CommonModule, DecimalPipe } from '@angular/common'
import { Component, Input, OnInit } from '@angular/core'
import { RouterModule } from '@angular/router'
import { NzIconModule } from 'ng-zorro-antd/icon'
import { forkJoin } from 'rxjs'
import { AtomModule } from '../../atom/atom.module'
import { Asset, Product, SearchResult } from '../../gql/generated'
import { AcfService } from '../../service/acf.service'
import { AssetService } from '../../service/asset.service'
import { ProductService } from '../../service/product.service'

@Component({
  selector: 'app-game-card-gamma',
  templateUrl: './game-card-gamma.component.html',
  styleUrl: './game-card-gamma.component.less',
  standalone: true,
  imports: [AtomModule, CommonModule, RouterModule, DecimalPipe, NzIconModule],
})
export class GameCardGammaComponent implements OnInit {
  @Input() data!: SearchResult
  product: Product

  developer: string
  publisher: string
  releaseDate: string
  videoAssset: Asset
  mainAsset: Asset
  discountPercentage = 60 // Based on the image showing -60%

  platforms = [
    { label: 'PC', icon: 'ng-zorro:pc' },
    { label: 'Xbox', icon: 'ng-zorro:xbox' },
    { label: 'PlayStation', icon: 'ng-zorro:playstation' },
    { label: 'Nintendo', icon: 'ng-zorro:nintendo' },
    { label: 'Mobile', icon: 'ng-zorro:mobile' },
  ]

  get visiblePlatforms() {
    return this.platforms.slice(0, 2)
  }

  get remainingPlatformsCount() {
    return Math.max(0, this.platforms.length - 2)
  }

  get hasMorePlatforms() {
    return this.remainingPlatformsCount > 0
  }

  constructor(
    private productService: ProductService,
    private acfService: AcfService,
    private assetService: AssetService
  ) {}

  ngOnInit(): void {
    this.fetch()
  }

  fetch(): void {
    console.log(this.data)
    const entityName = 'Product'
    const entityId = this.data.productId

    if (this.data && this.data.productId) {
      // Create observable for parallel execution
      forkJoin({
        product: this.productService.fetchProduct(this.data.slug),
        // developer: this.acfService.getNestedValue<string>(entityName, entityId, 'gameInformation.gameInformationDeveloper'),
        // publisher: this.acfService.getNestedValue<string>(entityName, entityId, 'gameInformation.gameInformationPublisher'),
        // releaseDate: this.acfService.getNestedValue<string>(entityName, entityId, 'gameInformation.gameInformationReleaseDate'),
        // discountPercentage: this.acfService.getNestedValue<number>(entityName, entityId, 'gameCardContent.discountPercentage'),
        // videoAsset: this.acfService.getNestedValue<Asset>(entityName, entityId, 'gameCardContent.videoAsset'),
        // mainAsset: this.acfService.getNestedValue<Asset>(entityName, entityId, 'gameCardContent.mainAsset')
      }).subscribe((results) => {
        this.product = results.product as Product
        // this.developer = results.developer
        // this.publisher = results.publisher
        // this.releaseDate = results.releaseDate
        // this.discountPercentage = results.discountPercentage || 60 // Default to 60% if not specified
        // this.videoAssset = results.videoAsset
        // this.mainAsset = results.mainAsset
      })
    }
  }

  calculateDiscountedPrice(originalPrice: number): number {
    if (!this.discountPercentage || this.discountPercentage <= 0) {
      return originalPrice
    }
    const discount = originalPrice * (this.discountPercentage / 100)
    return originalPrice - discount
  }
}
